module.exports = __webpack_public_path__ + "img/right_3.a88c6c50.jpg";